import { render, staticRenderFns } from "./position.vue?vue&type=template&id=2f6e5b26&scoped=true&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./position.vue?vue&type=style&index=1&id=2f6e5b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e5b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6e5b26')) {
      api.createRecord('2f6e5b26', component.options)
    } else {
      api.reload('2f6e5b26', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=2f6e5b26&scoped=true&", function () {
      api.rerender('2f6e5b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/advertisement/position.vue"
export default component.exports